var _polygon, _polygon2, _path, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-204"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.21,
    y: 389.21,
    width: 25.46,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 394.62,
    width: 60.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.46,
    y: 389.33,
    width: 62.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 396.81,
    width: 13.04,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.71,
    y: 396.81,
    width: 59.38,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 392.59,
    width: 38.45,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62,256.57s-.44,13-17.62,13-17.62-13-17.62-13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.27,256.57s-.45,13-17.62,13-17.62-13-17.62-13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.34,
    y: 278.15,
    width: 39.43,
    height: 95.39,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.91,
    y: 373.54,
    width: 127.51,
    height: 8.86,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.77,
    y: 278.15,
    width: 103.22,
    height: 95.39,
    transform: "translate(324.76 651.7) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.27,
    y: 289.76,
    width: 72.21,
    height: 29.35,
    transform: "translate(324.76 608.87) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.27,
    y: 327.47,
    width: 72.21,
    height: 29.35,
    transform: "translate(324.76 684.29) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.77,
    y: 269.6,
    width: 108.47,
    height: 8.55,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.83,
    y: 269.6,
    width: 44.94,
    height: 8.55,
    transform: "translate(176.6 547.76) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.15,
    y: 75.96,
    width: 200.95,
    height: 144.26,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.58 220.22 253.7 75.96 292.06 75.96 240.94 220.22 202.58 220.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.73 220.22 356.84 75.96 370.83 75.96 319.72 220.22 305.73 220.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.68,71H181.57a.9.9,0,0,0-.9.89h0a.9.9,0,0,0,.9.9H401.68a.9.9,0,0,0,.9-.9h0A.9.9,0,0,0,401.68,71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.43,
    y: 75.65,
    width: 2.38,
    height: 144.88,
    transform: "translate(583.25 296.18) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.82,
    y: 75.65,
    width: 1.19,
    height: 144.88,
    transform: "translate(586.82 296.18) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.43,
    y: 46.23,
    width: 2.38,
    height: 203.73,
    transform: "translate(143.53 439.72) rotate(-90)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.49,219.23h0V74.57H189.76V219.23h0v2.38H393.49Zm-201.35,0V77h199V219.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.49,
    y: 74.57,
    width: 1.19,
    height: 147.04,
    transform: "translate(788.17 296.18) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.95 68.82 363.95 238.23 406.96 238.23 399.07 68.82 363.95 68.82",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.49 68.82 220.49 238.23 177.48 238.23 185.37 68.82 220.49 68.82",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.89,
    y: 260.67,
    width: 211.16,
    height: 34.81,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.82,
    y: 262.74,
    width: 77.68,
    height: 30.67,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.38,
    y: 262.74,
    width: 77.68,
    height: 30.67,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.74 382.4 286.08 382.4 296.05 295.48 300.71 295.48 290.74 382.4",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.67 382.4 245 382.4 254.97 295.48 259.64 295.48 249.67 382.4",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.19 382.4 420.86 382.4 410.89 295.48 406.22 295.48 416.19 382.4",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.26 382.4 461.93 382.4 451.96 295.48 447.29 295.48 457.26 382.4",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.77 222.33 333.44 222.33 326.64 260.67 342.97 260.67 349.77 222.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.09 189 294.76 189 297.54 244.56 388.87 244.56 386.09 189",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.99 190.32 296.99 190.32 299.64 243.24 386.64 243.24 383.99 190.32",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.42,
    y: 254.55,
    width: 3.21,
    height: 1.48,
    rx: 0.72,
    transform: "translate(820.05 510.58) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.89,191.74l-19.8,19.8a14,14,0,0,1,19.8-19.8Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.39,194l7.72,7.72,10-10-7.72-7.71a7.06,7.06,0,0,0-10,0h0A7.06,7.06,0,0,0,416.39,194Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.49,
    y: 176.48,
    width: 1.67,
    height: 46.6,
    transform: "translate(540.43 623.4) rotate(-135)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 213.14,
    width: 1.67,
    height: 46.6,
    transform: "translate(854.59 238.54) rotate(149.33)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.39,
    cy: 184.05,
    r: 2.88,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.82,
    cy: 216.28,
    r: 1.84,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.25 255.28 412.82 255.28 413.89 260.67 398.19 260.67 399.25 255.28",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-204"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-204",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.31,251.79H104.76a12.38,12.38,0,0,1-12.28-12L89.35,104.67a11.7,11.7,0,0,1,11.72-12H339.62a12.38,12.38,0,0,1,12.28,12L355,239.79A11.7,11.7,0,0,1,343.31,251.79Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.31,252.29H104.76A12.86,12.86,0,0,1,92,239.81L88.85,104.68a12.19,12.19,0,0,1,12.22-12.51H339.62a12.86,12.86,0,0,1,12.78,12.49l3.13,135.12a12.19,12.19,0,0,1-12.22,12.51ZM101.07,93.17a11.19,11.19,0,0,0-11.22,11.49L93,239.78a11.85,11.85,0,0,0,11.78,11.51H343.31a11.2,11.2,0,0,0,11.22-11.48L351.4,104.68a11.85,11.85,0,0,0-11.78-11.51Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.31,251.79H106.76a12.38,12.38,0,0,1-12.28-12L91.35,104.67a11.7,11.7,0,0,1,11.72-12H341.62a12.38,12.38,0,0,1,12.28,12L357,239.79A11.7,11.7,0,0,1,345.31,251.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.31,252.29H106.76A12.86,12.86,0,0,1,94,239.81L90.85,104.68a12.19,12.19,0,0,1,12.22-12.51H341.62a12.86,12.86,0,0,1,12.78,12.49l3.13,135.12a12.19,12.19,0,0,1-12.22,12.51ZM103.07,93.17a11.19,11.19,0,0,0-11.22,11.49L95,239.78a11.85,11.85,0,0,0,11.78,11.51H345.31a11.2,11.2,0,0,0,11.22-11.48L353.4,104.68a11.85,11.85,0,0,0-11.78-11.51Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.23,130.48l-16.13-15c7.63-8.24,21.19-8.24,30,0a23.42,23.42,0,0,1,6.2,9.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.87,130.81l-21,1.85a20.89,20.89,0,0,1,.52-9.12,19.36,19.36,0,0,1,4.37-7.75Z",
    style: {
      fill: "#99246A",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.23,132l-11.64,12.58a19.78,19.78,0,0,1-3.91-5.06,18.71,18.71,0,0,1-2-6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.36,133.71l20.11-5.5a20.36,20.36,0,0,1-4,20.52c-7.63,8.24-21.19,8.24-30,0Z",
    style: {
      fill: "#99246A",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.48,130.48l-16.13-15c7.63-8.24,21.19-8.24,30,0a23.45,23.45,0,0,1,6.21,9.52Z",
    style: {
      fill: "#99246A",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.11,130.81l-21,1.85a20.74,20.74,0,0,1,.53-9.12,19.22,19.22,0,0,1,4.36-7.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.48,132l-11.65,12.58a19.78,19.78,0,0,1-3.91-5.06,18.71,18.71,0,0,1-2-6Z",
    style: {
      fill: "#99246A",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.6,133.71l20.11-5.5a20.33,20.33,0,0,1-4,20.52c-7.63,8.24-21.19,8.24-30,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.93,232.37h-.05a.52.52,0,0,1-.45-.55c1.14-11.78,8.44-23.07,19.53-30.19,9.61-6.17,21.82-9.29,35.39-9,3.48.07,7,.36,10.43.65a110.53,110.53,0,0,0,15.67.54c5.85-.35,16.59-2.14,22.75-10.24a42.64,42.64,0,0,0,5-9.68c1.66-4,3.37-8.21,6.44-11.43,4.08-4.29,10.35-6.73,18.65-7.26a117,117,0,0,1,12.85.12c3.69.17,7.51.35,11.26.2,6.62-.26,15.77-1.85,21.74-8,2.74-2.8,4.64-6.38,6.48-9.84,1-1.8,1.95-3.67,3.06-5.43A41.33,41.33,0,0,1,311,118a.49.49,0,0,1,.67.2.51.51,0,0,1-.2.68,40.35,40.35,0,0,0-15,14c-1.09,1.73-2.08,3.58-3,5.37-1.87,3.52-3.8,7.16-6.65,10.07-4.91,5-12.66,7.89-22.42,8.27-3.78.15-7.62,0-11.33-.2a117.8,117.8,0,0,0-12.75-.12c-8,.51-14.09,2.85-18,7-2.94,3.08-4.61,7.17-6.24,11.12a43.28,43.28,0,0,1-5.11,9.91c-6.41,8.41-17.47,10.27-23.5,10.63a110.73,110.73,0,0,1-15.8-.55c-3.4-.28-6.92-.57-10.37-.64-13.33-.28-25.39,2.79-34.83,8.85-10.83,7-18,18-19.07,29.45A.52.52,0,0,1,106.93,232.37Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.09,122.94H313a.5.5,0,0,1-.35-.61l1.09-4.25a10.15,10.15,0,0,1,.47-1.42.11.11,0,0,0,0-.11,48.92,48.92,0,0,0-9.39,1.16.49.49,0,0,1-.59-.38.49.49,0,0,1,.38-.59,51.69,51.69,0,0,1,9.5-1.22,1.09,1.09,0,0,1,.92.46,1.11,1.11,0,0,1,.11,1.07,10,10,0,0,0-.42,1.28l-1.1,4.25A.49.49,0,0,1,313.09,122.94Z",
    style: {
      fill: "#99246A"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.44,111.89s-14-6.14-18.11,11.17C333,137,326,142.22,326,142.22s24.75,9.56,38.55-1.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.17,170.17c-.51,1.38-1,2.56-1.54,3.8s-1.1,2.43-1.67,3.63c-1.15,2.4-2.45,4.72-3.77,7a86.58,86.58,0,0,1-9.27,13.13l-.67.76c-.24.27-.36.44-.86.95a7.9,7.9,0,0,1-3.34,2,8.23,8.23,0,0,1-3.55.2,11.2,11.2,0,0,1-2.74-.8,19.52,19.52,0,0,1-4-2.4,38.48,38.48,0,0,1-3.22-2.77,69.15,69.15,0,0,1-9.94-12.52l3.55-2.68a103,103,0,0,0,10.88,10,20.82,20.82,0,0,0,5.52,3.24c.8.27,1.35.15,1.21.11s-.13,0-.1,0,.22-.29.38-.51l.55-.72a102.05,102.05,0,0,0,7.9-12.32c1.18-2.16,2.28-4.37,3.35-6.59.53-1.11,1.05-2.22,1.55-3.34s1-2.29,1.4-3.3Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.32,158.14C331.58,158,325,171.6,325,171.6l9.73,11.79s11.34-14.23,9.79-18.83C342.86,159.77,340.76,158.33,335.32,158.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.7 161.42 329.64 177.27 334.2 182.78 334.7 161.42",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.35,184.78,286,182.16l7-5.53s5.2,2.19,5.53,5.83Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.15 177.72 286.52 173.72 292.96 176.63 285.95 182.16 281.15 177.72",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.73 402.23 352.95 402.23 353.38 381.89 362.16 381.89 361.73 402.23",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.1,401.21H362a.7.7,0,0,1,.7.6l1.12,7.81a1.41,1.41,0,0,1-1.41,1.56c-3.44-.06-5.1-.26-9.44-.26-2.67,0-10.33.28-14,.28s-3.88-3.65-2.35-4c6.88-1.48,11.74-3.52,14.06-5.47A2.3,2.3,0,0,1,352.1,401.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "353.38 381.89 353.16 392.38 361.94 392.38 362.17 381.89 353.38 381.89"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M331.79,162.49c-.19,5.56.77,18.53,6.61,48.72l35.66-1.06c-1-14.49-1.31-23.44,4.74-53.43a106.25,106.25,0,0,0-15.2-1.55,113.39,113.39,0,0,0-16.2.49c-4.12.5-8.57,1.35-11.49,2A5.17,5.17,0,0,0,331.79,162.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.45,137c-.87,5.24-1.6,14.82,2.15,18.18A20.2,20.2,0,0,1,351.23,164c-8.22-4.17-3.83-8.34-3.83-8.34,5.77-1.56,5.49-5.87,4.36-9.89Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.23 164 352.29 161.92 358 163.21 351.23 164",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,161.92c1.84-.84,10.32-6.36,10.65-8.09.67.73,4.26.95,4.26.95s-2.15,9.87-6.31,17.09C358.05,165.43,355.35,163.92,352.29,161.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.23 164 350.75 161.92 347.25 162.17 351.23 164",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.75,161.92c-2.83-1.88-2.14-5.81-1.86-7.53-.67.72-4.26.94-4.26.94s-5.08,9.32-.91,16.54C345.69,166.69,347.69,163.92,350.75,161.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.5,140.57l-5.73,5.2a17.27,17.27,0,0,1,.58,2.86c2.21-.39,5.19-2.92,5.35-5.25A7.8,7.8,0,0,0,357.5,140.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.3,125c-.11,8.72,0,12.41-4.14,17.08-6.28,7-17,5-19.46-3.58-2.24-7.71-1.69-20.67,6.65-24.55A11.89,11.89,0,0,1,364.3,125Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.59,129.19h0l-10.95-.54a.25.25,0,0,1-.24-.26.25.25,0,0,1,.27-.24l10.95.54a.25.25,0,0,1,.23.27A.24.24,0,0,1,363.59,129.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.4,211.21s4.51,65.25,7,91.92c2.61,27.75,6,87.22,6,87.22h11.87s2.48-60.48,1.54-87.85c-1-29.83-.37-92.06-.37-92.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.37 390.77 350.44 390.77 349.41 386.33 365.02 385.78 364.37 390.77",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.35,233.74c-1.44-1.6-3-.77-4.78,3.79-5.93,15.56.39,40.39,5,54.69C364.26,274.42,364.27,251,364.35,233.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,128.76c0,.71-.32,1.3-.78,1.32s-.86-.53-.9-1.24.31-1.3.78-1.32S350,128.05,350,128.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,129c0,.71-.32,1.3-.78,1.32s-.86-.53-.9-1.24.31-1.3.78-1.32S342,128.24,342,129Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.29,127.74l-1.72-.41S340.51,128.62,341.29,127.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.08,129.53a18.81,18.81,0,0,1-2.3,4.64,3,3,0,0,0,2.55.35Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.32,137.1a6.56,6.56,0,0,1-1,.13.21.21,0,0,1-.22-.2.22.22,0,0,1,.2-.21,5.58,5.58,0,0,0,4.46-2.42.21.21,0,0,1,.29-.07.2.2,0,0,1,.07.28A5.8,5.8,0,0,1,349.32,137.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,132.86a6.34,6.34,0,0,1-3.14,3.71c-2,1-3.42-.67-3.23-2.78.17-1.89,1.41-4.71,3.59-4.84A2.86,2.86,0,0,1,367,132.86Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.13,126.32a.4.4,0,0,1-.44-.2c-.95-1.67-3.42-1.93-3.44-1.94a.41.41,0,1,1,.08-.82c.12,0,2.92.3,4.08,2.35a.41.41,0,0,1-.15.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.42,124.92a.39.39,0,0,1-.39-.13.41.41,0,0,1,0-.59,4.14,4.14,0,0,1,3.64-1.06.42.42,0,0,1,.3.51.43.43,0,0,1-.51.3h0a3.24,3.24,0,0,0-2.87.87A.42.42,0,0,1,339.42,124.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.2,166.8c1.17,4.67,2.39,9.43,3.64,14.11s2.62,9.35,4.13,13.87,3.38,9,5.11,13.6,3.49,9.24,5.08,13.93l-4,1.89c-2.6-4.24-5-8.55-7.37-12.93q-1.75-3.28-3.42-6.64c-1.13-2.21-2.2-4.59-3.15-7-1.91-4.74-3.5-9.51-4.92-14.31s-2.72-9.6-3.82-14.54Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.8,156.72c3.6,1,8.26,13.15,8.26,13.15l-13.57,10.32s-5.36-10.11-4-14.78C370.92,160.56,374.68,155.6,378.8,156.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.8,402.75a3.34,3.34,0,0,1-2.13-.54,1.18,1.18,0,0,1-.38-1,.68.68,0,0,1,.36-.55c1.07-.59,4.57,1.2,5,1.4a.22.22,0,0,1,.11.22.19.19,0,0,1-.17.17A14.65,14.65,0,0,1,348.8,402.75Zm-1.57-1.82a.81.81,0,0,0-.38.07.26.26,0,0,0-.14.23.74.74,0,0,0,.24.67c.53.48,2,.56,3.92.24A11.19,11.19,0,0,0,347.23,400.93Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.52,402.44l-.08,0c-1.05-.48-3.12-2.37-3-3.36,0-.24.21-.53.78-.59a1.5,1.5,0,0,1,1.16.36c1.1.92,1.3,3.28,1.31,3.38a.21.21,0,0,1-.09.19A.21.21,0,0,1,351.52,402.44Zm-2.09-3.56h-.12c-.38,0-.41.19-.42.24-.09.6,1.31,2.09,2.38,2.74a4.83,4.83,0,0,0-1.12-2.71A1.06,1.06,0,0,0,349.43,398.88Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.27 402.23 404.49 402.23 399.17 381.89 407.96 381.89 413.27 402.23",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.35,401.21h-9.87a.53.53,0,0,0-.57.6l.6,7.81a1.84,1.84,0,0,0,1.75,1.56c3.43-.06,5-.26,9.38-.26,2.67,0,5.33.28,9,.28s3.08-3.65,1.47-4c-7.21-1.48-7.45-3.52-10.2-5.47A2.79,2.79,0,0,0,413.35,401.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "399.18 381.89 401.91 392.38 410.7 392.38 407.96 381.89 399.18 381.89"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M374.06,210.15c10.15,13.6,16.33,63.54,20.82,90.24,4.67,27.77,16.15,90,16.15,90H399.16s-16.15-63.3-24.61-90.1c-9.35-29.59-23.32-90.1-23.32-90.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.88 390.77 397.94 390.77 396.92 386.33 412.53 385.78 411.88 390.77",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.52,401.46a3.31,3.31,0,0,0,1.69-1.41,1.16,1.16,0,0,0-.1-1.08.67.67,0,0,0-.55-.34c-1.23-.07-3.62,3.05-3.89,3.41a.21.21,0,0,0,0,.24.19.19,0,0,0,.22.08A14.67,14.67,0,0,0,414.52,401.46Zm.63-2.32a.9.9,0,0,1,.38-.1.25.25,0,0,1,.22.15.74.74,0,0,1,.08.7c-.28.66-1.55,1.36-3.44,1.91A11.42,11.42,0,0,1,415.15,399.14Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.93,402.35a.18.18,0,0,0,.07-.05c.74-.88,1.79-3.48,1.22-4.31-.14-.2-.42-.39-1-.19a1.53,1.53,0,0,0-.89.82c-.6,1.3.24,3.52.27,3.62a.21.21,0,0,0,.16.13A.19.19,0,0,0,411.93,402.35Zm.35-4.11.12-.05c.36-.13.45,0,.47,0,.35.49-.28,2.44-1,3.49a4.82,4.82,0,0,1-.16-2.93A1.06,1.06,0,0,1,412.28,398.24Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.29,127.55l-1.72-.41S348.51,128.43,349.29,127.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.53,208l1,3.17c.13.24-.16.5-.57.52l-36.7,1.09c-.32,0-.59-.14-.62-.34l-.41-3.19c0-.22.24-.41.59-.42l36.11-1.08A.67.67,0,0,1,374.53,208Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.8,212.23l1,0c.19,0,.33-.11.32-.23l-.58-4.14c0-.12-.19-.21-.38-.21l-1,0c-.19,0-.33.11-.32.23l.58,4.14C369.44,212.14,369.61,212.23,369.8,212.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,213.08l1,0c.19,0,.33-.11.32-.23l-.58-4.13c0-.12-.19-.22-.38-.21l-1,0c-.19,0-.33.11-.32.23l.58,4.13C340.64,213,340.81,213.09,341,213.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.4,212.65l1,0c.19,0,.33-.11.32-.24l-.58-4.13c0-.12-.19-.21-.38-.21l-1,0c-.19,0-.33.11-.32.23l.58,4.13C355,212.57,355.21,212.66,355.4,212.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.15,220.73l7,6.41-8.86,1.14s-3.32-4.55-1.74-7.84Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.34 234.43 400.87 234.98 398.27 228.28 407.13 227.15 408.34 234.43",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.5,112.8s-7.37-3.38-15.5,6.87c9.79,2.91,16.37.89,16.37.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.44,111.89s1.78,25.77,0,38.61c10.34-3.28,20.23-13.51,20.23-13.51S373.22,108.78,354.44,111.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.19,134.73c-2.32,0-4.45-2.87-4.76-6.4a7.16,7.16,0,0,1,1.44-5.38,3,3,0,0,1,2.25-1.06c2.32,0,4.46,2.87,4.77,6.4h0a7.12,7.12,0,0,1-1.45,5.38A3,3,0,0,1,349.19,134.73Zm-1.07-12.34a2.56,2.56,0,0,0-1.88.89,6.68,6.68,0,0,0-1.31,5c.28,3.27,2.2,5.94,4.26,5.94a2.5,2.5,0,0,0,1.88-.9,6.66,6.66,0,0,0,1.32-5h0C352.1,125.05,350.19,122.39,348.12,122.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.48,134.73c-1.88,0-3.6-2.81-3.91-6.4-.21-2.41.29-4.6,1.3-5.7a2.08,2.08,0,0,1,1.54-.74c1.88,0,3.59,2.81,3.91,6.4h0c.2,2.41-.3,4.59-1.31,5.7A2.08,2.08,0,0,1,340.48,134.73Zm-1.07-12.34a1.54,1.54,0,0,0-1.17.58c-.91,1-1.37,3.08-1.17,5.32.27,3.22,1.84,5.94,3.41,5.94a1.57,1.57,0,0,0,1.16-.58c.91-1,1.37-3.08,1.18-5.32h0C342.54,125.11,341,122.39,339.41,122.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.68,128.56l-.11,0a1.46,1.46,0,0,0-1.37,0,.25.25,0,0,1-.34-.08.24.24,0,0,1,.07-.34,2,2,0,0,1,1.85,0,.26.26,0,0,1,.13.33A.28.28,0,0,1,344.68,128.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-204"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.33,
    y: 280.84,
    width: 273.33,
    height: 9.33,
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.33,
    y: 280.84,
    width: 273.33,
    height: 9.33,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.67,
    y: 280.84,
    width: 80,
    height: 9.33,
    style: {
      fill: "#99246A",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.17 414.67 320.84 414.67 313.75 290.17 326.17 290.17 326.17 414.67",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.33 414.67 386.67 414.67 379.58 290.17 367.16 290.17 381.33 414.67",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.67 414.67 113.33 414.67 120.42 290.17 132.84 290.17 118.67 414.67",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.83 414.67 179.16 414.67 186.25 290.17 173.83 290.17 173.83 414.67",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.45,236.14H244.13a3,3,0,0,0-2.85,2.43L234.9,275.1a2,2,0,0,0,2,2.42h58.31a3,3,0,0,0,2.85-2.42l6.38-36.53A2,2,0,0,0,302.45,236.14Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.45,236.14H244.13a3,3,0,0,0-2.85,2.43L234.9,275.1a2,2,0,0,0,2,2.42h58.31a3,3,0,0,0,2.85-2.42l6.38-36.53A2,2,0,0,0,302.45,236.14Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.33,236.14H243a3,3,0,0,0-2.85,2.43l-6.38,36.53a2,2,0,0,0,2,2.42h58.31A3,3,0,0,0,297,275.1l6.38-36.53A2,2,0,0,0,301.33,236.14Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.33,236.14H243a3,3,0,0,0-2.85,2.43l-6.38,36.53a2,2,0,0,0,2,2.42h58.31A3,3,0,0,0,297,275.1l6.38-36.53A2,2,0,0,0,301.33,236.14Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.8,276.52a1.05,1.05,0,0,1-.82-.34,1.12,1.12,0,0,1-.2-.91l6.38-36.53a2,2,0,0,1,1.86-1.6h58.31a1.06,1.06,0,0,1,.82.35,1.11,1.11,0,0,1,.2.91L296,274.92a2,2,0,0,1-1.86,1.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.4,277.52H221.06a3.27,3.27,0,0,0-3.25,3.25h79.84A3.27,3.27,0,0,0,294.4,277.52Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.4,277.52H221.06a3.27,3.27,0,0,0-3.25,3.25h79.84A3.27,3.27,0,0,0,294.4,277.52Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.4,277.52H278.06a3.27,3.27,0,0,0-3.25,3.25h22.84A3.27,3.27,0,0,0,294.4,277.52Z",
    style: {
      fill: "#99246A",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.91,
    y: 264.52,
    width: 13.09,
    height: 16.32,
    rx: 1.19,
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.63,272.47l.19-.94h-.9v-1H323l.26-1.32h1l-.27,1.32h.81l.27-1.32h1.05l-.27,1.32h.51v1h-.71l-.19.94h.9v1h-1.11l-.26,1.3H324l.26-1.29h-.81l-.26,1.3h-1l.26-1.3h-.51v-1Zm1.05,0h.81l.19-.94h-.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.4,269.2v5.5h-1.52v-3.61a4.48,4.48,0,0,1-.71.46,6.73,6.73,0,0,1-.87.33v-1.23a3.82,3.82,0,0,0,1.2-.6,2.41,2.41,0,0,0,.66-.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.23,279.05c-2.59,0-4.62-2.8-4.62-6.37s2.07-6.38,4.62-6.38,4.62,2.86,4.62,6.38S337.82,279.05,335.23,279.05Zm0-11.28c-1.71,0-3.15,2.24-3.15,4.91s1.44,4.9,3.15,4.9,3.15-2.24,3.15-4.9S336.93,267.77,335.23,267.77Z",
    style: {
      fill: "#99246A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.55,234.11l-.93,1.44-1,1.58c-.65,1.06-1.28,2.14-1.91,3.23-1.24,2.18-2.44,4.39-3.55,6.63a91.35,91.35,0,0,0-5.59,13.71c-.36,1.16-.68,2.32-1,3.48l-.41,1.75-.17.87-.09.44c0,.14-.06.33-.06.29s-.08,0-.18-.26a1.48,1.48,0,0,0-.48-.58c-.17-.1-.2,0-.11.09a3,3,0,0,0,.69.47,11.2,11.2,0,0,0,2.69.92,32.9,32.9,0,0,0,3.43.61c2.38.31,5,.46,7.46.59h.25a3.51,3.51,0,0,1,1,6.81,43.27,43.27,0,0,1-8.52,2.11,26.28,26.28,0,0,1-9.78-.25,14.11,14.11,0,0,1-3-1.11,11.56,11.56,0,0,1-3.22-2.42,10.57,10.57,0,0,1-2.34-4.1,11.86,11.86,0,0,1-.41-4.24c0-.38,0-.52.06-.71l.07-.55.13-1.12c.11-.73.21-1.47.33-2.2.25-1.46.53-2.91.88-4.33a87.5,87.5,0,0,1,5.74-16.33c1.21-2.58,2.5-5.12,3.91-7.59.7-1.24,1.44-2.46,2.2-3.67.38-.61.77-1.21,1.18-1.82s.79-1.16,1.31-1.88a7,7,0,0,1,11.57,7.86Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.29,193.75c.1.68.54,1.17,1,1.11s.72-.67.62-1.34-.54-1.17-1-1.11S208.19,193.08,208.29,193.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.77,194.93a24.41,24.41,0,0,0,4.08,5.29,3.92,3.92,0,0,1-3.13,1.08Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.34,190.37a.33.33,0,0,0,.22-.11,3.15,3.15,0,0,1,2.74-.93.41.41,0,0,0,.48-.31.4.4,0,0,0-.31-.47,3.94,3.94,0,0,0-3.47,1.14.41.41,0,0,0,0,.57A.42.42,0,0,0,205.34,190.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.48,201.2c.29,6.3-.19,17.68-5.08,21.13,0,0,.75,6.45,12.12,8.15,12.49,1.86,6.9-5.32,6.9-5.32-6.58-2.64-5.65-7.68-3.75-12.25Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.44,224.85c-.49-2.85-1-6.1,1.15-6.6,2.36-.55,14.58,1.08,18.44,4s1.88,8,1.88,8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.39,235.47c.46,10.08,0,30.07-6.84,60.33H162.33c-.28-6.29,6.21-33.41,5.65-63.21a11.26,11.26,0,0,1,11.23-11.47c.89,0,1.83,0,2.8.11a160.45,160.45,0,0,1,19.06,2.48c1.88.43,3.71.93,5.37,1.44A11.32,11.32,0,0,1,214.39,235.47Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.56,253.61c-.72,5.12-2.38,14,3.61,23.82.68-4.07,1.23-7.88,1.68-11.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.8,266l7.61-2.62-3.1-8a9.65,9.65,0,0,0-7.69,6.27Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.44 261.1 255.25 254.64 247.31 255.3 250.41 263.33 254.44 261.1",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.34,234.54c.42,1.47.94,3.18,1.44,4.78s1,3.24,1.58,4.85c1.08,3.22,2.27,6.39,3.52,9.49s2.65,6.11,4.16,8.92a39.48,39.48,0,0,0,5,7.43l-7.33-1.13c1.41-.61,2.86-1.24,4.32-2s2.95-1.44,4.42-2.24l4.5-2.37c1.5-.79,3-1.65,4.53-2.39l.16-.08a3.54,3.54,0,0,1,4.41,5.3,53.52,53.52,0,0,1-3.58,4.25c-1.25,1.35-2.56,2.63-3.92,3.89s-2.8,2.45-4.3,3.59-3.09,2.24-4.78,3.26a5.78,5.78,0,0,1-6.94-.77l-.39-.37a47,47,0,0,1-7.65-9.67,85.91,85.91,0,0,1-5.35-10.15c-1.57-3.43-2.92-6.91-4.15-10.41-.61-1.75-1.2-3.51-1.73-5.28s-1-3.51-1.51-5.47a7,7,0,0,1,13.53-3.61Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.58,195.69c1.75,8.2,2.35,13.09,7.17,16.72,7.25,5.46,16.91.14,17.65-8.43.66-7.71-2.3-19.83-10.9-21.92A11.45,11.45,0,0,0,185.58,195.69Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.25,196.55c3.92-.3,3.69-2.11,2.81-3.44s-1.95-6.11-1.95-6.11,5.45,1.44,4.33-3.78-8.48-11.83-14.91-7.78c-12.81-2.11-17,3.06-15,7.84-10.17,4.5-2.83,13.61,1.22,13.61-3.61,3.22,1.78,7.86,10.52,13.07C196.67,202.25,206.11,204.32,203.25,196.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.33,178.06a1,1,0,0,1-.71-.31A12.08,12.08,0,0,0,183,174.58a1,1,0,0,1-1.2-.74,1,1,0,0,1,.74-1.2,14.18,14.18,0,0,1,13.54,3.72,1,1,0,0,1,0,1.41A1,1,0,0,1,195.33,178.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.08,206a1,1,0,0,1-.71-.29c-2.82-2.84-4-5.06-3.64-7a4.54,4.54,0,0,1,2.84-3.24,1,1,0,0,1,.86,1.81c-1.05.5-1.61,1.08-1.73,1.77s.28,2.42,3.09,5.24a1,1,0,0,1,0,1.42A1,1,0,0,1,182.08,206Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.43,195.91a9.54,9.54,0,0,0,3.7,4.84c2.29,1.51,3.84-.2,3.54-2.67-.27-2.23-1.79-5.7-4.25-6.23S197.66,193.52,198.43,195.91Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.62,407.35c1.08,0,2.13-.15,2.48-.63a.77.77,0,0,0,0-.88,1,1,0,0,0-.63-.47c-1.41-.38-4.36,1.3-4.49,1.38a.18.18,0,0,0-.09.2.2.2,0,0,0,.15.17A15.85,15.85,0,0,0,276.62,407.35Zm1.34-1.64a1.46,1.46,0,0,1,.38.05.6.6,0,0,1,.4.28c.14.25.09.37,0,.44-.4.55-2.54.56-4.11.34A9.15,9.15,0,0,1,278,405.71Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.06,407.12l.08,0c1-.45,3.05-2.28,2.89-3.24,0-.22-.19-.5-.74-.56a1.49,1.49,0,0,0-1.11.34c-1.08.89-1.31,3.17-1.32,3.26a.21.21,0,0,0,.09.18A.15.15,0,0,0,274.06,407.12Zm2.07-3.43h.12c.36,0,.38.18.39.22.09.58-1.28,2-2.33,2.64a4.71,4.71,0,0,1,1.12-2.61A1.08,1.08,0,0,1,276.13,403.69Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.45 406.92 272.91 406.92 271.3 387.34 262.84 387.34 264.45 406.92",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.92,405.94h-9.23a.62.62,0,0,0-.64.58L262.5,414a1.46,1.46,0,0,0,1.44,1.51c3.32-.06,8.1-.25,12.29-.25,4.89,0,5.4.26,11.14.26,3.47,0,3.91-3.51,2.41-3.82-6.82-1.45-8.49-1.61-14.73-5.13A4.42,4.42,0,0,0,272.92,405.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.29 387.35 272.13 397.44 263.67 397.44 262.84 387.35 271.29 387.35",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,407.35a2.77,2.77,0,0,0,2-.55.85.85,0,0,0,0-1,.94.94,0,0,0-.63-.46c-1.23-.29-3.57,1.31-3.67,1.38a.21.21,0,0,0-.08.2.18.18,0,0,0,.15.15A10.21,10.21,0,0,0,224,407.35Zm1.06-1.61a1,1,0,0,1,.25,0,.55.55,0,0,1,.37.27c.18.33.07.47,0,.51-.36.48-2.09.48-3.35.27A6.5,6.5,0,0,1,225,405.74Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.82,407.12l.09,0c.88-.48,2.57-2.33,2.39-3.27a.66.66,0,0,0-.64-.53,1.09,1.09,0,0,0-.85.26c-1,.8-1.19,3.24-1.19,3.34a.2.2,0,0,0,.09.19A.2.2,0,0,0,221.82,407.12Zm1.7-3.43h.09c.26,0,.29.15.3.2.1.56-1,2-1.85,2.62a4.83,4.83,0,0,1,1-2.65A.72.72,0,0,1,223.52,403.69Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.08 406.92 222.53 406.92 226.78 387.34 218.33 387.34 214.08 406.92",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.13,405.94h-9.49a.73.73,0,0,0-.72.58L211.25,414a1.24,1.24,0,0,0,1.23,1.51c3.32-.06,4.93-.25,9.11-.25,2.57,0,5.86.26,9.41.26s4-3.51,2.56-3.82c-6.51-1.43-7-3.39-9.05-5.27A2.06,2.06,0,0,0,223.13,405.94Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194,295.8s46.9,14.23,48.06,33.07c2.13,34.7-14.89,64.27-14.89,64.27H214.49s4.82-14.66,6.55-46.09c2.17-39.5-72.52.92-58.71-51.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "218.32 387.35 226.78 387.35 224.59 397.44 216.13 397.44 218.32 387.35"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M207.55,295.8s60.65,4,63.05,36.19c2.75,37,3.55,61.15,3.55,61.15H261.59s-6.46-22.69-12-55.31c-1.67-9.77-22.39-11.45-42-12.61-16.9-1-29.88-2-31.3-20.72l.22-8.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.22,389.78c.07,0-.81,6-.81,6H259l-.47-5.31Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,389.78c.07,0-1.6,6-1.6,6H212l.32-5.31Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.82,322.56l-8.49-57.67a6.57,6.57,0,0,0-6.5-5.62H139.74a6.57,6.57,0,0,0-6.5,7.53l8.2,55.76h0a4.88,4.88,0,0,0,4.89,4.88h91.31a4.88,4.88,0,0,0-4.89-4.88Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.82,322.56l-8.49-57.67a6.57,6.57,0,0,0-6.5-5.62H139.74a6.57,6.57,0,0,0-6.5,7.53l8.2,55.76h0a4.88,4.88,0,0,0,4.89,4.88h91.31a4.88,4.88,0,0,0-4.89-4.88Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.83,259.27H139.74a6.57,6.57,0,0,0-6.5,7.53l8.2,55.76a4.88,4.88,0,0,0,4.89,4.88h53.11Z",
    style: {
      fill: "#99246A",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 416.24 139.25 416.24 146.33 327.44 149.17 327.44 142.08 416.24",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.08 416.24 139.25 416.24 146.33 327.44 149.17 327.44 142.08 416.24",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.23 416.24 187.4 416.24 194.49 327.44 197.32 327.44 190.23 416.24",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.23 416.24 187.4 416.24 194.49 327.44 197.32 327.44 190.23 416.24",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.59 416.24 191.75 416.24 184.67 327.44 187.5 327.44 194.59 416.24",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.59 416.24 191.75 416.24 184.67 327.44 187.5 327.44 194.59 416.24",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.74 416.24 239.91 416.24 232.82 327.44 235.65 327.44 242.74 416.24",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.74 416.24 239.91 416.24 232.82 327.44 235.65 327.44 242.74 416.24",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.4dd831730406339d3349dd73510eb5f9.svg";
export { ForwardRef as ReactComponent };